import Vue from 'vue'
import Snotify, { SnotifyPosition } from 'vue-snotify/vue-snotify.min.js'
import VeeValidate, {Validator} from 'vee-validate'
import VueCookies from 'vue-cookies'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import App from './App.vue'


// Plugins
import GlobalComponents from './gloablComponents'
import GlobalDirectives from './globalDirectives'
import GlobalPlugins from './globalPlugins'
import ModalPlugin from './components/ModalPlugin'

// router setup
import router from './router'

// store
import store from './store'

import moment from 'moment'

// library imports
import './pollyfills'
import 'es6-promise/auto'
import './assets/sass/element_variables.scss'
import './assets/sass/paper-dashboard.scss'
import './assets/sass/demo.scss'
import * as Sentry from '@sentry/browser'

if(window.location.href.endsWith('login/naric')) {
  window.location.href = 'https://qcas.qualificationcheck.com/#/login'
}

Sentry.init({
  Vue,
  dsn: 'https://90bde2661fa3499eadf8ec2b619a2fdc@sentry.io/1288824',
  environment: process.env.NODE_ENV,
    // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,
  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 1.0,
  // release: version,
  integrations: [new Sentry.Replay()]
})

// plugin setup
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(GlobalPlugins)
Vue.use(ModalPlugin)
Vue.use(Snotify, {
  icon: false,
  toast: {
    position: SnotifyPosition.centerTop,
    bodyMaxLength: 1500
  }
})
Vue.use(VeeValidate)
Vue.use(VueCookies)
locale.use(lang)

const dictionary = {
  custom: {
    dob: {
      date_format: "The date of birth must be a valid date in the format DD/MM/YYYY"
    },
    password: {
      regex: "Invalid password"
    },
    newpassword: {
      regex: "Invalid password"
    }
  }
}

// Override and merge the dictionaries
Validator.localize('en', dictionary);

var timeout
function refresh() {
  clearTimeout(timeout)
  timeout = setTimeout(() => {
    if(store.state.autoLogout && moment().isAfter(store.state.autoLogout)) {
      store.commit('logout')
      router.push('/login?expired=true')
      refresh()
    } else {
      refresh()
    }
  }, 10000)
}
refresh()

store.commit('initState')

store.commit('setBranding', window.location.host)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  store,
  router
})
